import React, { Component } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { bindActionCreators } from "redux";
import { createFieldAction } from "../../../../../../modules/fields/action";
import "../../../../../../style";
import FieldForm from "./FieldForm";


class CreateField extends Component {
  constructor(props) {
    super(props);

    this.state = {
      successMessage: "",
      errorMessage: {}
    };
  }

  handleSubmit = formData => {
    this.props.createFieldAction(formData);
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.fieldCreated && nextProps.fieldCreated.status === 200) {
      this.setState({ successMessage: true });
    }
  }

  render() {
    const { successMessage } = this.state;
    if (successMessage) {
      return <Redirect to="/farmsetup/farminformation/field-groups/fields" />;
    }
    return (
      <FieldForm
        buttonLabel="Add new field"
        formLabel="Set up your field"
        handleSubmit={this.handleSubmit}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    fieldCreated: state.fieldReducer.fieldCreated
  };
}

const mapDispatchToProps = dispatch =>
  bindActionCreators({ createFieldAction }, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CreateField);



// WEBPACK FOOTER //
// ./src/components/private/FarmInformation/parts/FieldGroups/Fields/CreateField.js